import { useCallback } from "react";
import { useViewport } from "@bookingcom/bui-react";
import { useFormatDateTime } from "@bookingcom/flights-core";
import { useI18n } from "@bookingcom/lingojs-react";
import getTechnicalStopsUtil from "../../../../utils/get-technical-stops.js";
export function useTimelineLegController() {
    const i18n = useI18n();
    const { formats } = useFormatDateTime(i18n);
    const { isSmall } = useViewport();
    const getDeparture = useCallback((from) => ({
        date: formats.flightDateWeekday(from.departureTime || ""),
        time: formats.flightTime(from.departureTime || ""),
        iata: from.airportCode,
        name: from.airport,
        timestampAttributes: { "data-testid": "timeline_location_timestamp_departure" },
        airportAttributes: { "data-testid": "timeline_location_airport_departure" }
    }), [formats]);
    const getArrival = useCallback((to) => ({
        date: formats.flightDateWeekday(to.arrivalTime || ""),
        time: formats.flightTime(to.arrivalTime || ""),
        iata: to.airportCode,
        name: to.airport,
        timestampAttributes: { "data-testid": "timeline_location_timestamp_arrival" },
        airportAttributes: { "data-testid": "timeline_location_airport_arrival" }
    }), [formats]);
    const getTechnicalStops = useCallback((leg) => getTechnicalStopsUtil.fromLeg(leg), []);
    const getTimelineLegFormattedData = useCallback((leg) => ({
        departure: getDeparture(leg.from),
        arrival: getArrival(leg.to),
        technicalStops: getTechnicalStops(leg),
        isSmall
    }), [getDeparture, getArrival, getTechnicalStops, isSmall]);
    return { getTimelineLegFormattedData };
}
